import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyShortAnswer = ({ option, hasVoted, onOptionUpdated }) => {
    const handleSelect = (event) => {
        onOptionUpdated(option.ballotOptionId, event.target.value)
    };

    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
            <input type="text"
                id={option.ballotOptionId}
                disabled={hasVoted}
                onChange={handleSelect}
                value={option.textValue != null ? option.textValue : ''}
                className="max-w-none"
                maxLength={option.surveyAnswerMaxCharacters !== null ? option.surveyAnswerMaxCharacters : undefined}
            />
        </React.Fragment>
    );
}